import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { normalize, schema } from "normalizr";

import { showError } from "../../utils/sagasErrorHandler";

import { getBranchesRequest } from "./api";
import { getBranches, setBranches } from "./actions";
import { branchesSelector } from "./selectors";

const branchesSchema = new schema.Entity("branches" , {},{ idAttribute: "code" });
const branchesListSchema = new schema.Array(branchesSchema);

export function* getBranchesWorker() {
    try {
        const { codes } = yield select(branchesSelector);
        if(!codes.length){
            yield put(setBranches({ isLoadingBranch: true }));
            const { branches } = yield call(getBranchesRequest);
            const { result, entities } = normalize(branches, branchesListSchema);
            yield put(setBranches({
                isLoadingBranch: false,
                codes: result,
                branches: entities.branches
            }));
        }
    } catch (error) {
        yield put(setBranches({ isLoadingBranch: false }));
        showError(error);
    }
}

export function* getBranchesSagas() {
    yield all([
        yield takeLatest(getBranches, getBranchesWorker)
    ]);
}
